import { createApp } from 'vue'

import App from './App.vue'
import './assets/index.css'
import './assets/scrollbar.css'
import './assets/themes.css'
import './assets/chart-theme.css'
import './assets/styles/iconfont.css'
import './styles/ally-tokens.css' // Ally Lab brand tokens (Shopify-green ramp + cream surfaces)
import 'vue-sonner/style.css' // vue sonner style

import '@/utils/env'
// Eager side-effect import for benchmarks plan-override URL/session cache sync.
// Ensures `?plan=free|pro|enterprise` works even on the /#/login page (before
// Home or Benchmarks routes ever mount benchmarks.api.ts lazily).
import '@/services/api/benchmarks.api'

import { setupPlugins } from './plugins'
import router from './router'

function bootstrap() {
  const app = createApp(App)

  setupPlugins(app)

  // 开发环境：如果需要调试付费功能，可以取消下面的注释
  // 注意：这会覆盖真实的计划数据，测试真实计划状态时请保持注释
  // if (import.meta.env.DEV) {
  //   // 延迟执行以确保 pinia 已安装
  //   setTimeout(() => {
  //     try {
  //       const userStore = useUserStore()
  //       userStore.setPlanProTrial()
  //       console.log('Dev: Plan set to Pro Trial')
  //
  //       // Expose to window for debugging
  //       ;(window as any).userStore = userStore
  //     } catch (e) {
  //       console.error('Dev: Failed to set plan', e)
  //     }
  //   }, 100)
  // }

  app.use(router)
  app.mount('#app')
}

bootstrap()
